import React, { ReactElement, ReactNode } from 'react';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import {
  referencedOrganisationToSelectedOrganisation,
  SelectedOrganisation,
  selectedOrganisationToReferencedOrganisation,
} from '../suggester/OrganisationSuggester';
import { ReferencedOrganisationDTO } from '../../../../api/core';
import { Panel } from '../layout/Panel';
import { Actions, MultiInputControls } from '../../../components/form/MultiInput/MultiInputControls';
import { InputGroup } from '../layout/InputGroup';
import { LabelledOrganisationSuggester } from '../../../components/form/LabelledOrganisationSuggester';

interface ProjectPartnerProps {
  checkPermission: CheckPermissionFunction;
  organisations: ReferencedOrganisationDTO[];
  onChange: (referencedOrganisations: ReferencedOrganisationDTO[]) => void;
  validation: ValidationResult;
  multiple: boolean;
  label: string;
  autoFocus: boolean;
}

export function ReferencedOrganisations(props: ProjectPartnerProps): ReactNode {
  return (
    <Panel
      title={props.label}
      toggleable={true}>
      <MultiInputControls<ReferencedOrganisationDTO>
        lines={props.organisations}
        onChange={props.onChange}
        canEdit={props.checkPermission().canWrite}
        addNew={(rows: ReferencedOrganisationDTO[]): number => rows.push(null)}
        max={props.multiple ? undefined : 1}
        renderLines={(organisation: ReferencedOrganisationDTO, onLineChange: (newValues) => void, actions: Actions, idx: number): ReactElement => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <LabelledOrganisationSuggester
                id={`partner${idx}`}
                autoFocus={props.autoFocus}
                value={(organisation ? [organisation].map(referencedOrganisationToSelectedOrganisation) : [])}
                permissions={props.checkPermission('id')}
                validation={props.validation}
                onChange={(selected: SelectedOrganisation[]): void => onLineChange(selected.length > 0 ? selected.map(selectedOrganisationToReferencedOrganisation).pop() : null)}
                multiple={false}
              />
            </InputGroup>
          );
        }}
      />
    </Panel>
  );
}
